import React from "react";
import Head from "next/head";

export const StylesFromPageTheme = ({
    font: fontProp,
    colors = {},
}: {
    font: {
        slug?: string;
        title: string;
        url: string;
    };
    colors?: {
        [key: string]: string;
    };
}) => {
    const { url: fontUrl, title } = fontProp || {};

    const colorVariablesStyle = Object.entries(colors)
        .map(([key, value]) => {
            const cssVarName = `--${key}`;
            return `${cssVarName}: ${value};`;
        })
        .join(" ");

    return (
        <Head>
            {/* @import fontUrl('${fontUrl}') is causing an extra network call, with listing uuid as '&', which slows 
                the processing of checkout page, so we are using link tag,
                also read: https://stackoverflow.com/questions/12316501/including-google-fonts-link-or-import */}
            {fontUrl && (
                // Check - https://web.dev/articles/defer-non-critical-css
                <link
                    href={fontUrl}
                    rel="preload"
                    as="style"
                    // @ts-ignore
                    onLoad={`this.onload=null;this.rel='stylesheet'`}
                />
            )}
            {title && (
                <style>
                    {`* {
                        font-family: ${title}, Montserrat, sans-serif;
                    }`}
                </style>
            )}
            {colorVariablesStyle && (
                <style>
                    {`:root {
                        ${colorVariablesStyle}
                    }`}
                </style>
            )}
        </Head>
    );
};

StylesFromPageTheme.defaultProps = {
    colors: {},
};
